import React, { useState } from "react";
import CustomInput from "src/app/components/CustomInput/CustomInput";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import Modal, {
  ModalText,
  ModalTitle,
  OutsideClickModes,
} from "src/app/components/Modal/Modal";

import { CUSTOM_URL_REGEX } from "src/types";
import { useIntl } from "react-intl";
import { translateMessage } from "src/app/methods/translateMessage";
import { showToast } from "src/app/methods/showToast";
import { showErrorToast } from "src/utils/methods";
import axios from "axios";
import { API_URLS } from "src/utils/API_URLS";

import "./AddSingleSocialProfileModal.scss";

interface Props {
  onClose: () => void;
}

const AddSingleSocialProfileModal = (props: Props) => {
  const { onClose } = props;

  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);

  const intl = useIntl();

  const handleConfirm = async () => {
    setLoading(true);

    try {
      await axios.post(API_URLS.createSocialProfile, {
        socialUrl: value,
      });

      showToast(
        "info",
        <IDHFormattedMessage id="ws_got_it" defaultMessage="Got it." />,
        <IDHFormattedMessage
          id="ws_we_are_adding_this_profile_now_we_will_let_you_know_as_soon_as_its_ready"
          defaultMessage="We’re adding this profile now. We’ll let you know as soon as it’s ready."
        />,
      );
      onClose();
    } catch (error) {
      if (
        axios.isAxiosError(error) &&
        error.response?.data?.content?.errors.length > 0
      ) {
        error.response?.data?.content?.errors.forEach((message: string) => {
          showErrorToast({
            id: message,
            defaultMessage: message,
          });
        });
      } else {
        showErrorToast();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      className="add-single-social-profile-modal"
      onClose={onClose}
      onCancelClick={onClose}
      displayCancelButton
      closeButtonText={
        <IDHFormattedMessage id="ws_cancel" defaultMessage="Cancel" />
      }
      closeButtonVariant="white-with-light-grey-border"
      confirmButtonText={
        <IDHFormattedMessage id="ws_confirm" defaultMessage="Confirm" />
      }
      confirmButtonVariant="blue"
      onConfirmClick={handleConfirm}
      confirmButtonDisabled={!CUSTOM_URL_REGEX.test(value)}
      confirmButtonLoading={loading}
      outsideClick={OutsideClickModes.Allow}
    >
      <ModalTitle>
        <IDHFormattedMessage
          defaultMessage="Add Social Profile"
          id="ws_add_social_profile"
        />
      </ModalTitle>
      <ModalText>
        <IDHFormattedMessage
          id="ws_enter_the_link_to_the_profile_you_want_to_add"
          defaultMessage="Enter the link to the profile you want to add."
        />
      </ModalText>
      <CustomInput
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={translateMessage({
          intl,
          id: "ws_enter_the_link",
          defaultMessage: "Enter the link",
        })}
      />
    </Modal>
  );
};

export default AddSingleSocialProfileModal;
